export function meetsMinTripadvisorRating(rating: string | undefined): boolean {
  return !!rating && parseFloat(rating) >= 3.5
}
